/** @jsxImportSource @emotion/react */
import { ArrowForwardIos } from '@mui/icons-material';
import { Button, Grid, Paper, Snackbar, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useFormik } from 'formik';
import { useEffect, useState,useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ElevatedGrid from '../../Components/ElevatedGrid';
import FullScreenLoader from '../../Components/FullScreenLoader';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import config from '../../config';
import axios from '../../Helper/Axios/interceptor';
import PageLayout from '../Layout/PageLayout';
import * as yup from 'yup';
import { StyledTextField } from '../../Components/CustomTextfield';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Il8nContext  } from '../../Helper/i18n';


function Courier(props) {
    const [kycData, setkycData] = useState()
    const [loading, setLoading] = useState(false)
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [responseStatus, setResponseStatus] = useState({})
    const localeText = useContext(Il8nContext)
    const navigate = useNavigate()
    const theme = useTheme()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const esignStatus = localStorage.getItem("esignStatus") || undefined



    const classes = {
        padding: {
            padding: '25px 45px',
        },
        title: {
            color: "#2A2A2A",
            fontWeight: 600,
            marginBottom: theme.spacing(5)
        },
        underline: {
            borderBottom: "2px solid #F54040",
            padding: "0px 16px 8px 0px"
        },
        textMargin: {
            marginBottom: theme.spacing(2)
        },
        font: {
            fontSize: '14px'
        },
        button: {
            padding: '10px 50px',
            marginTop: theme.spacing(2.5),
            marginBottom: theme.spacing(2.5)
        },
        weightedFont: {
            fontWeight: "600",
            color: "#000"
        },
        textGrid: {
            marginTop: theme.spacing(1.5),
            marginBottom: theme.spacing(1.5),
            cursor: 'pointer'
        },
        text: {
            color: '#969696'
        },
        textColor: {
            color: '#000'
        },
        loaderHeight: {
            height: '45px',
            marginBottom: '25px'
        },
        padding1: {
            padding: '25px 30px'
        },
        errorMsg: {
            fontSize: "16px",
            height: "20px",
            color: "#f44336",
            marginBottom: theme.spacing(1)
        },
        edsUL: {
            textAlign: "justify",
            listStyle: "none",
            paddingLeft: "10px"
        },
        icon: {
            fontSize: "12px",
            color: "#F54040"
        }
    }

    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        gtag('event', 'conversion', { 'send_to': 'AW-932277619/EFi0CL2P9M0BEPPaxbwD' });

        if (localStorage.getItem("POA") == "done") {
            localStorage.removeItem("POA")
            nextNavigation()
        }
        getKYCData()
    }, [])

    function handleSnackBarClose() {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const nextNavigation = () => {
        navigate("/Scrutiny")
    }

    const getKYCData = () => {
        setLoading(true)
        axios.get(process.env.REACT_APP_API_URL + config.kycData)
            .then(resp => {
                if (resp.data.success) {
                    setkycData(resp.data.success[0])
                    setLoading(false)
                }
                else {
                    throw new Error(resp.data.error)
                }
            })
            .catch((err) => {
                setLoading(false)
                console.log(err.message)
            })
    }

    function addDays(days) {
        let date = new Date()
        date.setDate(date.getDate() + days)
        date = new Date(date.getTime())
        return date
    }

    function handleAddress() {
        let obj = kycData
        if (obj.kycHolders && obj.kycHolders[0] && obj.kycHolders[0].kycContacts && obj.kycHolders[0].kycContacts[0]) {
            return (obj.kycHolders[0].kycContacts[0].corrAddress1 + " " + obj.kycHolders[0].kycContacts[0].corrAddress2 + ", " + obj.kycHolders[0].kycContacts[0].corrAddress3 + ", " +
                obj.kycHolders[0].kycContacts[0].corrAddressCity + "-" + obj.kycHolders[0].kycContacts[0].corrAddressPincode + ", " + obj.kycHolders[0].kycContacts[0].corrAddressState + ", " + obj.kycHolders[0].kycContacts[0].corrAddressCountry)
        }
        return ""
    }

    const submitPOAPickup = () => {
        let objData = {
            kycid: kycData.kycid || "",
            location: handleAddress(),
            Landmark: "",
            PickUpDate: addDays(1).getTime(),
            TimeSlot: "8.00am - 12.00pm",
            isEsign: true
        }
        setLoading(true)
        axios.post(process.env.REACT_APP_API_URL + config.addCourier, objData)
            .then(resp => {
                if (resp.data.success) {
                    setLoading(false)
                    nextNavigation()
                } else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setLoading(false)
                setResponseStatus({ "message": err.message, "type": "error" })
                setSnackBarOpen(true)
            })
    }

    const handleCourierSubmit = (data) => {
        if (localStorage.getItem("esignStatus")) {
            localStorage.removeItem("esignStatus")
        }
        let objData = {
            courierCompanyName: data.courierName,
            courierReferenceNumber: data.courierNumber,
            courierDispatchDate: String(new Date(data.dispatchDate).getTime()),
            isEsign: false
        }
        setLoading(true)
        axios.post(process.env.REACT_APP_API_URL + config.addCourier, objData)
            .then(resp => {
                if (resp.data.success) {
                    setLoading(false)
                    nextNavigation()
                } else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setLoading(false)
                setResponseStatus({ "message": err.message, "type": "error" })
                setSnackBarOpen(true)
            })
    }

    const handleNext = (data) => {
        if (localStorage.getItem("esignStatus") == "done") {
            submitPOAPickup()
        } else {
            handleCourierSubmit(data)
        }
    }

    const validationSchema = yup.object({
        courierName: yup
            .string('')
            .matches(/^[A-Za-z]{1}[A-Za-z0-9 \.]*$/, localeText?.CourierValidCourier)
            .required(localeText?.CourierName),
        courierNumber: yup
            .string('')
            .matches(/^[A-Za-z]{1}[A-Za-z \.]*$/, localeText?.CourierValidCourier)
            .required(localeText?.CourierNumber),
        dispatchDate: yup
            .date('')
            .required(localeText?.CourierDispatchDate)
    });

    const formik = useFormik({
        initialValues: {
            courierName: "",
            courierNumber: "",
            dispatchDate: addDays(1),
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            handleNext(values)
        }
    });

    return (
        <>
            {loading && <FullScreenLoader />}

            <PageLayout css={{ overflowY: "scroll" }} hideSidebarGrid={isSmallScreen ? true : false} calculateHeight={isSmallScreen ? true : false}>
                <ElevatedGrid >
                    <Grid container spacing={3} css={{ padding: "20px" }}>
                        {esignStatus ?
                            <>
                                <Grid item xs={12}>
                                    <Typography fontSize={"24px"} fontWeight={"bold"} color="#525D72" css={{ margin: "10px 0px" }}>
                                        {"EDIS"}
                                    </Typography>
                                    <Typography variant={"body1"} css={{ margin: "10px 0px" }}>
                                        {localeText?.CourierInform}
                                    </Typography>
                                    <Typography variant={"body1"} >
                                        <span style={{ fontWeight: "bold" }}>{localeText?.CourierTerms}</span>
                                    </Typography>
                                    <Typography variant={"body1"} css={{ lineHeight: "2" }}>
                                        <ul css={classes.edsUL}>
                                            <li>
                                                <ArrowForwardIos css={classes.icon} /> {localeText?.CourierEdisModule} <a color="red" href={process.env.REACT_APP_LOGIN_URL} target={"_blank"} >{localeText?.CourierLogin}</a> {localeText?.CourierBo} {'=>'} {localeText?.CourierDematHolding} {'=>'} {localeText?.CourierEdis}
                                            </li>
                                            <li>
                                                <ArrowForwardIos css={classes.icon} /> {localeText?.CourierIndividual} (BO)
                                            </li>
                                            <li>
                                                <ArrowForwardIos css={classes.icon} /> {localeText?.CourierBORegistered}
                                            </li>
                                            <li>
                                                <ArrowForwardIos css={classes.icon} />  {localeText?.CourierLacs}
                                            </li>
                                            <li>
                                                <ArrowForwardIos css={classes.icon} />  {localeText?.CourierLimit}
                                            </li>
                                            <li>
                                                <ArrowForwardIos css={classes.icon} />   {localeText?.CourierCut}
                                            </li>
                                            <li>
                                                <ArrowForwardIos css={classes.icon} />  {localeText?.CourierUser}
                                            </li>
                                            <li>
                                                <ArrowForwardIos css={classes.icon} />  {localeText?.CourierBeneficiary}
                                            </li>
                                        </ul>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button css={classes.button} variant={"contained"} color={"primary"} /* disabled={showLoader} */ onClick={handleNext}>
                                        {/* {showLoader ? <CircularProgress size={24} style={{ marginLeft: '-20px', marginRight: '16px', color: '#00000042' }} /> : ""} */}
                                        {localeText?.CourierNext}
                                    </Button>
                                </Grid>
                            </>
                            :
                            <Grid container spacing={3} alignItems="flex-start">
                                <Grid item container xs={12} direction={"column"} alignItems={"center"} justifyContent={"center"} spacing={1}>
                                    <Grid item>
                                        <img src={"images/successful.png"} />
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="h5" align="center">
                                            <span style={{ color: "green", fontWeight: 600 }}>{localeText?.CourierCongratulation} </span>
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="h5" align="center">
                                            <span style={{ color: "green" }}>{localeText?.CourierSubmitted}</span>
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container item md={6} xs={12} justifyContent="center">
                                    <Grid item xs={12}>
                                        <ul style={{ fontSize: "15px" }}>
                                            <li style={{ margin: "20px 0px", marginTop: "0px", color: "#F54040" }}> <span style={{ color: "black" }}>{localeText?.CourierNow}</span></li>
                                            <li style={{ margin: "20px 0px", color: "#F54040" }}> <span style={{ color: "black" }}>{localeText?.CourierStick}</span></li>
                                            <li style={{ margin: "20px 0px", color: "#F54040" }}><span style={{ color: "black" }}>{localeText?.CourierLastly}</span></li>
                                            <span style={{ margin: "20px 0px" }}><span style={{ color: "#F54040" }}>{localeText?.CourierPleaseNote}</span> {localeText?.CourierScrutiny}</span>
                                        </ul>
                                    </Grid>
                                    <Grid item css={{textAlign:"center"}}>
                                        <img width={"50%"} src={"images/courier.svg"} alt="courier"/>
                                    </Grid>
                                </Grid>
                                <Grid container item md={6} xs={12}>
                                    <Grid item xs={12} css={{marginBottom:"10px"}}>
                                        <span style={{ fontWeight: 600, }}>{localeText?.CourierTransmitted}</span>  (<i>{localeText?.CourierOnly}</i>)
                                    </Grid>
                                    <Paper elevation={2}>
                                        <Grid container css={classes.padding} style={loading ? { paddingBottom: '0px' } : { background: '#f7f7f7', paddingBottom: '0px' }}>                                            
                                            <Grid item lg={4} md={4} sm={4} xs={4} css={{paddingBottom:"5px"}}>
                                                <Typography variant='body1' css={classes.weightedFont}>{localeText?.CourierClientName}</Typography>
                                            </Grid>
                                            <Grid item lg={8} md={8} sm={8} xs={8} css={{paddingBottom:"5px"}}>
                                                <Typography variant='body1' css={classes.weightedFont}>{`: ${kycData?.clientFirstName+' '+(kycData?.clientMiddleName ? kycData.clientMiddleName+' ':'')+kycData?.clientLastName}`}</Typography>
                                            </Grid>
                                            <Grid item lg={4} md={4} sm={4} xs={4} css={{paddingBottom:"5px"}}>
                                                <Typography variant='body1' css={classes.text}>{localeText?.CourierFormNumber}</Typography>
                                            </Grid>
                                            <Grid item lg={8} md={8} sm={8} xs={8} css={{paddingBottom:"5px"}}>
                                                <Typography variant='body1' css={classes.text}>{`: ${kycData?.formNo || ''}`}</Typography>
                                            </Grid>
                                            <Grid item lg={4} md={4} sm={4} xs={4} css={{paddingBottom:"25px"}}>
                                                <Typography variant='body1' css={classes.text}>{localeText?.CourierPanNumber}</Typography>
                                            </Grid>
                                            <Grid item lg={8} md={8} sm={8} xs={8} css={{paddingBottom:"25px"}}>
                                                <Typography variant='body1' css={classes.text}>{`: ${kycData?.panNo || ''}`}</Typography>
                                            </Grid>
                                        </Grid>
                                        <form autoComplete="off" onSubmit={formik.handleSubmit}>
                                            <Grid container css={loading ? classes.padding1 : classes.padding} spacing={1}>
                                                <Grid item xs={12} css={{ marginTop: "10px" }}>
                                                    <StyledTextField id="courierName" name="courierName"                                                         
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}                                                        
                                                        placeholder={"Enter Courier Name"}
                                                        value={formik.values.courierName}
                                                        error={formik.touched.courierName && Boolean(formik.errors.courierName)}
                                                        helperText={formik.touched.courierName && formik.errors.courierName} 
                                                        fullWidth
                                                        required
                                                        label={localeText?.CourierNa} 
                                                        variant="outlined"
                                                        onChange={formik.handleChange}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} css={{ marginTop: "10px" }}>
                                                    <StyledTextField id="courierNumber" name="courierNumber" 
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        placeholder={"Enter Courier Number"}
                                                        value={formik.values.courierNumber}
                                                        error={formik.touched.courierNumber && Boolean(formik.errors.courierNumber)}
                                                        helperText={formik.touched.courierNumber && formik.errors.courierNumber} 
                                                        fullWidth
                                                        required
                                                        label={localeText?.CourierAwb} 
                                                        variant="outlined"
                                                        onChange={formik.handleChange}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} css={{ marginTop: "10px" }}>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker css={{ width: "100%" }}
                                                            inputFormat="DD/MM/YYYY"
                                                            id="dispatchDate" name="dispatchDate"
                                                            value={formik.values.dispatchDate}
                                                            label={localeText?.CourierDate}
                                                            onChange={e => {
                                                                formik.setFieldValue("dispatchDate", e.$d)
                                                            }}
                                                            maxDate={addDays(7)}
                                                            minDate={addDays(1)}
                                                            renderInput={(params) => <StyledTextField
                                                                fullWidth
                                                                required
                                                                error={formik.touched.dispatchDate && Boolean(formik.errors.dispatchDate)}
                                                                helperText={formik.touched.dispatchDate && formik.errors.dispatchDate}
                                                                {...params}
                                                            />}
                                                        />
                                                    </LocalizationProvider>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Button type={"submit"} css={classes.button} variant={"contained"} color={"primary"}>
                                                        {localeText?.CourierSubmit}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </form>
                                    </Paper>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </ElevatedGrid>
            </PageLayout>

            {
                responseStatus && responseStatus.message && <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackBarOpen}
                    autoHideDuration={5000}
                    onClose={handleSnackBarClose}
                >
                    <MySnackbarContentWrapper
                        onClose={handleSnackBarClose}
                        variant={responseStatus.type}
                        message={responseStatus.message}
                    />
                </Snackbar>
            }
        </>
    );
}

export default Courier;